import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { CommonBaseModule } from './../common/common.module';
import { AppSharedModule } from './../shared/appShared.module';
import {
  ReceptionControlListResolver,
  ReceptionControlSupplierListResolver,
  ReceptionControlEditResolver,
  GoodsTypeByBusinessResolver,
  ReceptionControlDocumentResolver
} from './services/reception-control.resolver.service';
import { ReceptionControlService } from './services/reception-control.service';
import { ReceptionControlListComponent } from './components/reception-control-list.component';
import { ReceptionControlFormComponent } from './components/reception-control-form.component';
import { ReceptionControlComponent } from './reception-control.component';
import { EcplDocumentExplorerModule } from 'src/app/shared/ecpl-document-explorer';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ exports: [
        ReceptionControlComponent,
        ReceptionControlFormComponent,
        ReceptionControlListComponent
  ],
    declarations: [
    ReceptionControlComponent,
    ReceptionControlFormComponent,
    ReceptionControlListComponent
  ], imports: [AppSharedModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        CommonBaseModule,
        KubaExportModule,
        EcplDocumentExplorerModule
  ],
  providers: [
    ReceptionControlService,
    ReceptionControlListResolver,
    ReceptionControlSupplierListResolver,
    ReceptionControlEditResolver,
    GoodsTypeByBusinessResolver,
    ReceptionControlDocumentResolver,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class ReceptionControlModule {}
